module.exports = __webpack_public_path__ + "img/step_link@2x.a4be5808.png";